<div class="widget-wrapper align-self-center">

  <div class="topSection" *ngIf="!isMobile">
    <p class="trustedBy mb-1">{{"misc.trusted_by" | translate}}</p>
    <svg-icon src="/assets/images/svg-icons/pattern-widget.svg" [svgStyle]="{ 'width.px': '360', 'height.px': '20' }"></svg-icon>
    <app-feature></app-feature>
  </div>

  <div class="wallet-box">
    <!--User Details and Round timer -->
    <app-round-user-details [liveCounter]="liveCounter" [raisedInfo]="raisedInfo"></app-round-user-details>
    <!--User Details and Round timer -->

    <!-- Transaction Area -->
    <div class="swapArea" [ngClass]="{ cover: status === SwapStatus.in_progess || status === SwapStatus.confirm_pending || status === SwapStatus.approval_pending }">
      <p class="text-center mb-3 dashTitle" [ngClass]="{ shimmer: !usdRaised || usdRaised <= 0, 'mt-3': !walletAddress }">1 {{ tokenName }} = ${{ salePrice }}</p>

      <app-swap [isNative]="isNative" [isWert]="isWert" #swap *ngIf="walletAddress && dataLoaded"></app-swap>

      <div class="d-flex align-items-center justify-content-center gap-2 mt-4" *ngIf="!walletAddress">
        <button class="btn btn-primary w-100" (click)="isWert = true; connectModal()">{{ 'widget.buy_with_card' | translate }}</button>
        <button class="btn btn-secondary w-100" (click)="isWert = false; connectModal()">{{ 'widget.buy_with_crypto' | translate }}</button>
      </div>

      <div class="mt-2">
        <div class="mt-3 mb-2 w-100 d-flex justify-content-center align-items-center cursor-pointer" (click)="openBestWallet()" *ngIf="!walletAddress">
          <span class="d-inline-block text-white text-uppercase fs-8 text-decoration-underline">{{ 'widget.no_wallet_click_here' | translate }}</span>
        </div>

        <!--- dont have wallet-->

        <p class="fs-7 text-center fw-regular mb-0 d-flex align-items-center justify-content-center">
          <span class="me-2">{{ 'widget.powered_by' | translate }}</span>
          <a href="https://web3paymentsolutions.io" target="_blank">
            <img src="/assets/images/svg-icons/W3P_White.svg" alt="web3paymentsolutions" class="poweredByIcon text-tertiary" />
          </a>
        </p>
      </div>
    </div>
    <!-- Transaction Area -->
  </div>

  <a *ngIf="!isMobile" href="https://app.coinsult.net/eth/0xd29191a6d2aae7c0e60f4722018832addf4b9831" target="_blank" class="d-flex justify-content-center align-items-center gap-3 my-3">
    <div class="fs-7">{{ "widget.trust_safety" | translate }}</div>
    <svg-icon src="/assets/images/svg-icons/coin_sult.svg" [svgStyle]="{ 'width.px': '92', 'height.px': '23' }"></svg-icon>
  </a>

  <!-- <div class="tags" *ngIf="isMobile">
    <span class="outline-btn text-white">{{ 'banner.banner_desc_bottom' | translate }}</span>
  </div> -->


</div>
